import { Button, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link, To } from "react-router";

type ReviewPlanSuccessStateProps = {
    backHref: To;
    onReviewMoreClick: () => void;
    totalDraftVisits: number;
};

export function ReviewPlanSuccessState({ backHref, onReviewMoreClick, totalDraftVisits }: ReviewPlanSuccessStateProps) {
    const { t } = useTranslation("plannerV2");

    return (
        <Stack padding={2} justifyContent="center" rowGap={2}>
            <Typography variant="h6">{t("reviewPlanPanel.successTitle")}</Typography>
            <Typography variant="body1">{t("reviewPlanPanel.successMessage")}</Typography>
            {totalDraftVisits > 0 && (
                <Button variant="contained" onClick={onReviewMoreClick}>
                    {t("reviewPlanPanel.reviewMoreVisits", { count: totalDraftVisits })}
                </Button>
            )}
            <Button variant="outlined" component={Link} to={backHref}>
                {t("reviewPlanPanel.keepPlanning")}
            </Button>
        </Stack>
    );
}
